export class FormattersHelper {
    static formatMarkdown(text: string, isInsights: boolean = false): string {
        if (!text) return '';

        // Remove markdown headers (### or ##) at the start of lines
        let formatted = text.replace(/^#+\s*/gm, '');

        // Remove markdown dividers
        formatted = formatted.replace(/---+/g, '');

        // Replace bold markdown **...** with <strong>...</strong>
        formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

        // Replace italic markdown *...* with <em>...</em>
        formatted = formatted.replace(/\*(.*?)\*/g, '<em>$1</em>');

        // Remove bullet point dashes and format as single paragraph
        // Remove dashes at the start of lines and join into single paragraph
        formatted = formatted.replace(/^\s*-\s*/gm, '');

        // Remove standalone hyphens with spaces around them
        formatted = formatted.replace(/\s+-\s+/g, ' ');

        // Remove trailing hyphens at the end of sentences
        formatted = formatted.replace(/\s+-\s*$/gm, '');

        // Fix literal "\n" strings that often appear in encoded JSON streaming
        formatted = formatted.replace(/\\n/g, '<br />');

        // Convert actual newlines to breaks to preserve bullet point and list structures
        formatted = formatted.replace(/\n+/g, '<br />').trim();

        // Detect and format markdown tables - ONLY for Insights as per user request
        if (isInsights && formatted.includes('|')) {
            const lines = formatted.split('<br />');
            const processed: string[] = [];
            let inTable = false;
            let isHeaderRow = true;

            for (let i = 0; i < lines.length; i++) {
                const line = lines[i].trim();

                // Recognize a table line: must contain at least one pipe
                if (line.includes('|')) {
                    // Skip separator rows like |---|---|
                    if (line.replace(/[|\s-]/g, '') === '') continue;

                    const cells = line.split('|').filter((_, idx, arr) => {
                        // Keep cells that aren't the empty ones created by leading/trailing pipes
                        if (idx === 0 && arr[idx] === '') return false;
                        if (idx === arr.length - 1 && arr[idx] === '') return false;
                        return true;
                    });

                    if (cells.length > 0) {
                        const cellTags = cells.map(c => isHeaderRow ? `<th>${c.trim()}</th>` : `<td>${c.trim()}</td>`).join('');
                        let row = `<tr>${cellTags}</tr>`;

                        if (!inTable) {
                            inTable = true;
                            isHeaderRow = true; // First row is always header
                            processed.push(`<div class="markdown-table-wrapper"><table class="markdown-table"><thead><tr>${cells.map(c => `<th>${c.trim()}</th>`).join('')}</tr></thead><tbody>`);
                            isHeaderRow = false;
                        } else {
                            processed.push(row);
                        }
                        continue;
                    }
                }

                // If we reach here, the line is not a table line
                if (inTable) {
                    processed[processed.length - 1] += '</tbody></table></div>';
                    inTable = false;
                    isHeaderRow = true;
                }
                processed.push(line);
            }

            if (inTable) {
                processed[processed.length - 1] += '</tbody></table></div>';
            }

            // Join with <br /> only where it's NOT a table transition
            formatted = processed.map((item, idx) => {
                const isTablePart = item.includes('<table') || item.includes('<tr>') || item.includes('</table>');
                const nextIsTablePart = processed[idx + 1] ? (processed[idx + 1].includes('<table') || processed[idx + 1].includes('<tr>') || processed[idx + 1].includes('</table>')) : false;

                if (isTablePart || nextIsTablePart) return item;
                return item + '<br />';
            }).join('').replace(/(<br \/>)+$/g, '');
        }

        // Replace underscores with spaces
        formatted = formatted.replace(/_/g, ' ');

        // Clean up excessive whitespace but keep <br />
        formatted = formatted.replace(/[ \t]+/g, ' ').trim();

        return formatted;
    }
}
